import React from 'react';
import {
  Box, Icon, IconName, Text,
} from '@usealloy/component-library';
import BaseChangeContainer from './BaseChangeContainer';


export default function IneligibleChange() {
  return (
    <BaseChangeContainer
      style={{
        borderColor: 'var(--cl-yellow-300)',
      }}
    >
      <Box justifyContent="flex-start" gap={2}>
        <Icon icon={IconName.TriangleWarning} size="small" />
        <Text
          size={1}
          style={{
            color: 'var(--cl-grey-1100)',
            textAlign: 'left',
            lineHeight: '16px',
          }}
        >
          This change is not eligible for testing with What-If Analysis.
        </Text>
      </Box>
    </BaseChangeContainer>
  );
}
